import { motion } from "framer-motion";

export const Reveal = ({ children, as = "div", delay = 0, className = "" }) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            className={className}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 0.61, 0.36, 1] }}
        >
            {children}
        </Tag>
    );
};
